module.exports = __webpack_public_path__ + "img/fs-shenhechenggong.189c9cc2.png";